module.exports = __webpack_public_path__ + "static/Highlight6-647204559c5c6aaf9aa605ab7fb34802.png";